import { createContext, useState } from "react";

export const DeviceContext = createContext<any[]>([]);

export const DeviceProvider = (props: any) => {
    const [device, setDevice] = useState(null);

    return <DeviceContext.Provider value={[device, setDevice]} {...props} />;
};
